import React from 'react';
import { Link as RouterDomLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface LinkProps extends RouterLinkProps {
  reloadDocument?: boolean;
  replace?: boolean;
  state?: any;
  preventScrollReset?: boolean;
  relative?: 'route' | 'path';
  to:
    | string
    | Partial<{
        pathname: string;
        search: string;
        hash: string;
      }>;
}

const isBrowser =
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined';

let clicked = false;

export function MockupLinkHasBeenClicked(): boolean {
  return clicked;
}

const MockupLink = (): React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>> => {
  const link = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
    const { ...rest } = props;
    let { to } = props;
    const handleClick = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      clicked = true;
    };
    let href;
    if (isBrowser && typeof to === 'string') {
      href = to;
      if (/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(to)) {
        const currentUrl = new URL(window.location.href);
        const targetUrl = to.startsWith('//') ? new URL(currentUrl.protocol + to) : new URL(to);
        if (targetUrl.origin === currentUrl.origin) {
          // Strip the protocol/origin for same-origin absolute URLs
          to = targetUrl.pathname + targetUrl.search + targetUrl.hash;
        }
      }
    } else if (typeof to !== 'string') {
      const { pathname, search, hash } = to;
      href =
        (!pathname?.startsWith('http') ?? window.location.origin) +
        (pathname || '') +
        ((!pathname?.includes('?') && search && !search?.startsWith('?')) ?? '?') +
        (search || '') +
        ((!pathname?.includes('#') && hash && !hash?.startsWith('#')) ?? '#') +
        (hash || '');
    }
    return <a {...rest} href={href} onClick={handleClick} ref={ref} target={props.target} />;
  });
  link.displayName = 'Link';
  return link;
};

const RouterLink = (): React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>> => {
  if (window.hasOwnProperty('Cypress')) {
    return MockupLink();
  } else {
    return RouterDomLink;
  }
};

export default RouterLink();
